import { createContext, useContext, useState, useCallback } from "react";

const DICT = {
  "app.name": { zh: "魔法筆記本", en: "Magic Notebook" },
  "app.badge": { zh: "世界心情地圖", en: "World Mood Map" },

  "nav.map": { zh: "世界地圖", en: "World Map" },
  "nav.chat": { zh: "聊天", en: "Chat" },
  "nav.diary": { zh: "魔法日記", en: "Magic Diary" },
  "nav.journeys": { zh: "魔法旅程", en: "Journeys" },
  "nav.creatures": { zh: "奇幻生物", en: "Creatures" },
  "nav.stats": { zh: "回顧統計", en: "Insights" },
  "nav.manifest": { zh: "顯化魔法", en: "Manifest" },
  "sound.on": { zh: "水晶音效：開", en: "Crystal sound: On" },
  "sound.off": { zh: "水晶音效：關", en: "Crystal sound: Off" },
  "logout": { zh: "登出", en: "Log out" },

  "login.desc": {
    zh: "把你每天的心情、日記與小事，自動轉譯成依地區神話而變化的魔法旅程，並在一張發光的世界地圖上，與全世界分享美好時刻。",
    en: "Turn your daily moods, diaries and little moments into region-mythology magical journeys — and share your bright moments on a glowing world map.",
  },
  "login.enter": { zh: "開始你的魔法旅程，免註冊即可使用", en: "Start your magical journey — no signup" },
  "login.subnote": { zh: "無需登入 · 直接開始記錄你的魔法日記", en: "No login required · Start journaling right away" },
  "login.google": { zh: "使用 Google 登入", en: "Sign in with Google" },
  "feat.diary.t": { zh: "每日心情日記", en: "Daily Mood Diary" },
  "feat.diary.d": { zh: "記錄心情與三件開心小事", en: "Log your mood and 3 happy things" },
  "feat.ai.t": { zh: "AI 魔法轉譯", en: "AI Magic Translation" },
  "feat.ai.d": { zh: "把日常變成奇幻旅程故事", en: "Turn daily life into fantasy stories" },
  "feat.map.t": { zh: "世界心情地圖", en: "World Mood Map" },
  "feat.map.d": { zh: "在星圖上分享彼此的光", en: "Share your light on the star map" },

  "map.title": { zh: "世界心情地圖", en: "World Mood Map" },
  "map.sub": { zh: "點亮的每顆光球，都是世界某個角落的一則魔法故事 · 共 {count} 則分享", en: "Every glowing orb is a magic story from somewhere in the world · {count} shares" },
  "map.record": { zh: "記錄今天", en: "Log Today" },
  "map.latest": { zh: "最新魔法故事", en: "Latest Magic Stories" },
  "map.empty": { zh: "星圖尚未點亮，成為第一個在世界地圖留下魔法光球的人 ✨", en: "The star map is dark — be the first to light a magic orb ✨" },
  "map.hidden": { zh: "隱藏", en: "Hidden" },
  "map.likes": { zh: "讚", en: "likes" },
  "map.comments_label": { zh: "留言", en: "Comments" },
  "map.no_comments": { zh: "還沒有留言，留下第一則祝福吧 ✨", en: "No comments yet — leave the first blessing ✨" },
  "map.comment_ph": { zh: "寫下你的祝福...", en: "Write a blessing..." },
  "toast.commented": { zh: "已留言", en: "Comment posted" },

  "diary.title": { zh: "今日魔法日記", en: "Today's Magic Diary" },
  "diary.sub": { zh: "記錄你的心情，讓筆記本為你譜寫一段魔法旅程", en: "Record your mood and let the notebook weave a magical journey" },
  "diary.mood_label": { zh: "今天的心情", en: "Today's mood" },
  "diary.happy_label": { zh: "三件值得開心的小事", en: "Three happy little things" },
  "diary.happy_ph": { zh: "第 {n} 件開心的小事", en: "Happy thing #{n}" },
  "diary.sticker_hint": { zh: "點一下貼紙快速記錄 · 或自己打字", en: "Tap a sticker to log fast · or type your own" },
  "diary.sticker_custom": { zh: "自訂...", en: "Add your own..." },
  "diary.sticker_add": { zh: "加入", en: "Add" },
  "diary.picked": { zh: "已選 {n}/3", en: "Picked {n}/3" },
  "reveal.summon": { zh: "召喚你的今日夥伴...", en: "Summoning your companion..." },
  "reveal.appeared": { zh: "現身了！", en: "appeared!" },
  "reveal.tap": { zh: "點擊任意處繼續", en: "Tap anywhere to continue" },
  "streak.days": { zh: "連續 {n} 天", en: "{n}-day streak" },
  "streak.first": { zh: "魔法旅程開始！", en: "Your journey begins!" },
  "streak.keep": { zh: "火焰越燒越旺 🔥", en: "The flame grows brighter 🔥" },
  "diary.free_label": { zh: "自由補充", en: "Free notes" },
  "diary.voice": { zh: "語音輸入", en: "Voice input" },
  "diary.voice_stop": { zh: "停止", en: "Stop" },
  "diary.free_ph": { zh: "今天發生了什麼？寫下任何想記錄的事...", en: "What happened today? Write anything you like..." },
  "diary.country_label": { zh: "所在國家", en: "Country" },
  "diary.country_ph": { zh: "選擇國家（決定神話風格）", en: "Select country (sets myth style)" },
  "diary.image_label": { zh: "今日圖片", en: "Today's image" },
  "diary.upload": { zh: "上傳圖片", en: "Upload image" },
  "diary.uploaded": { zh: "已上傳，點擊更換", en: "Uploaded — tap to change" },
  "diary.auto_title": { zh: "自動測量今日旅程", en: "Auto-measure today's journey" },
  "diary.auto_sub": { zh: "用裝置定位自動偵測所在國家與移動距離，不用手動輸入", en: "Uses device location to auto-detect country & distance — no typing" },
  "diary.measure": { zh: "自動測量我的位置", en: "Measure my location" },
  "diary.measuring": { zh: "定位測量中...", en: "Measuring..." },
  "diary.detected": { zh: "已偵測位置", en: "Location detected" },
  "diary.distance": { zh: "自上次移動約 {km} 公里", en: "~{km} km since last time" },
  "diary.no_move": { zh: "目前沒有明顯移動", en: "No significant movement" },
  "diary.activity_ph": { zh: "做了什麼（如：開車去丟垃圾）", en: "What did you do? (e.g. drove to take out trash)" },
  "diary.translate": { zh: "開始魔法轉譯", en: "Begin Magic Translation" },
  "diary.translating": { zh: "AI 正在編織你的魔法旅程...", en: "AI is weaving your magical journey..." },
  "diary.saving": { zh: "儲存中...", en: "Saving..." },
  "diary.share": { zh: "分享到世界地圖", en: "Share to World Map" },
  "diary.shared": { zh: "已分享到世界地圖 🌍", en: "Shared to the World Map 🌍" },
  "companion.title": { zh: "魔法夥伴", en: "Magic Companion" },
  "companion.sub": { zh: "結合表達性藝術治療 · 陪你把心情安放", en: "Expressive-arts therapy · here to hold your feelings" },
  "companion.greeting": { zh: "嗨，今天過得如何呢？跟我說說一件讓你嘴角上揚的小事吧 ✨", en: "Hi, how was your day? Tell me one little thing that made you smile ✨" },
  "companion.ph": { zh: "和魔法夥伴聊聊...", en: "Chat with your companion..." },

  "t.pick_mood": { zh: "請先選擇今天的心情", en: "Please pick today's mood first" },
  "t.need3": { zh: "請填寫至少 3 件值得開心的小事", en: "Please add at least 3 happy things" },
  "t.img_fail": { zh: "圖片上傳失敗", en: "Image upload failed" },
  "t.img_ok": { zh: "圖片已上傳", en: "Image uploaded" },
  "t.translate_ok": { zh: "魔法轉譯完成 ✨", en: "Magic translation complete ✨" },
  "t.error": { zh: "發生錯誤，請稍後再試", en: "Something went wrong, please try again" },
  "t.geo_unsupported": { zh: "此裝置不支援定位", en: "Geolocation not supported on this device" },
  "t.geo_fail": { zh: "無法取得定位，請允許位置權限", en: "Could not get location — please allow location access" },
  "t.measured": { zh: "已自動測量位置與距離", en: "Location & distance measured" },
  "t.voice_unsupported": { zh: "此瀏覽器不支援語音輸入", en: "Voice input not supported in this browser" },

  "journeys.title": { zh: "魔法旅程回顧牆", en: "Journey Wall" },
  "journeys.sub": { zh: "你走過的每一段旅程，都化作了彩虹軌跡與星塵尾跡 · 共 {count} 段旅程", en: "Every journey becomes a rainbow trail and stardust wake · {count} journeys" },
  "journeys.empty_t": { zh: "還沒有魔法旅程", en: "No journeys yet" },
  "journeys.empty_s": { zh: "記錄今天的心情，開啟你的第一段旅程吧", en: "Log today's mood to begin your first journey" },
  "journeys.start": { zh: "開始記錄", en: "Start logging" },

  "creatures.title": { zh: "奇幻生物圖鑑", en: "Creature Codex" },
  "creatures.sub": { zh: "依心情與行為自動變化的魔法夥伴，收藏每天與你相遇的幸運生物", en: "Companions that shift with your mood — collect the lucky creatures you meet each day" },
  "creatures.create_t": { zh: "創造專屬奇幻生物", en: "Create your own creature" },
  "creatures.create_s": { zh: "描述你想像中的生物，AI 會為它生成完整設定", en: "Describe your creature and AI builds its full profile" },
  "creatures.concept_ph": { zh: "例如：一隻由晨霧與鈴聲組成的療癒小鹿", en: "e.g. a healing deer made of morning mist and bells" },
  "creatures.generate": { zh: "生成", en: "Generate" },
  "creatures.gen_img": { zh: "同時生成 AI 插畫（需多等一會兒）", en: "Also generate AI illustration (takes a bit longer)" },
  "creatures.my": { zh: "我的原創生物", en: "My original creatures" },
  "creatures.base": { zh: "基本生物庫", en: "Base creatures" },
  "creatures.trail": { zh: "軌跡", en: "Trail" },
  "creatures.codex_t": { zh: "我收服的魔法夥伴", en: "My Companions" },
  "creatures.codex_s": { zh: "每天跟夥伴聊天並施展魔法轉譯，就會有幸運生物加入收藏——同一隻出現越多次，你擁有的就越多隻", en: "Chat and cast Magic Translation daily — lucky creatures join your collection, and repeats stack up" },
  "creatures.codex_empty": { zh: "收藏還空空的——去跟魔法夥伴聊聊今天，施展魔法轉譯召喚你的第一隻幸運生物！", en: "Your collection is empty — chat about your day and cast Magic Translation to summon your first lucky creature!" },
  "creatures.codex_count": { zh: "收藏種類", en: "Species" },
  "creatures.codex_enc": { zh: "總擁有數", en: "Total owned" },
  "creatures.met_times": { zh: "相遇", en: "Met" },
  "creatures.times_unit": { zh: "次", en: "×" },
  "creatures.first_met": { zh: "初次相遇", en: "First met" },
  "creatures.go_diary": { zh: "去聊天", en: "Go chat" },
  "creatures.born": { zh: "新的奇幻生物誕生了 ✨", en: "A new creature is born ✨" },
  "creatures.need_concept": { zh: "請輸入你想像的生物概念", en: "Please enter a creature concept" },
  "creatures.gen_fail": { zh: "生成失敗", en: "Generation failed" },

  "stats.title": { zh: "回顧與統計", en: "Insights" },
  "stats.sub": { zh: "你的魔法冒險足跡", en: "Your magical adventure trail" },
  "stats.exercise": { zh: "運動打卡", en: "Exercise check-in" },
  "stats.total": { zh: "日記總數", en: "Total entries" },
  "stats.diary_streak": { zh: "日記連續天數", en: "Diary streak" },
  "stats.ex_streak": { zh: "運動連續天數", en: "Exercise streak" },
  "stats.best": { zh: "最佳 {n} 天", en: "Best {n} days" },
  "stats.types": { zh: "陪伴生物種類", en: "Creature types" },
  "stats.mood_dist": { zh: "心情分佈", en: "Mood distribution" },
  "stats.common": { zh: "常出現的生物", en: "Frequent creatures" },
  "stats.no_data": { zh: "還沒有資料", en: "No data yet" },
  "stats.calendar": { zh: "日記打卡日曆（近 6 週）", en: "Check-in calendar (last 6 weeks)" },

  "profile.guest": { zh: "訪客身分 · 資料暫存於此裝置", en: "Guest · data stored on this device" },
  "profile.save_t": { zh: "保存你的魔法旅程", en: "Save your magical journey" },
  "profile.save_d": { zh: "你目前以訪客身分使用，資料只存在這個裝置。綁定 Google 後即可跨裝置永久保存，現有的日記、旅程與生物都會自動保留 ✨", en: "You're a guest, so data lives only on this device. Link Google to keep everything across devices — your diaries, journeys and creatures carry over ✨" },
  "profile.bind": { zh: "一鍵綁定 Google 保存進度", en: "Link Google to save progress" },
  "profile.region_privacy": { zh: "地區與隱私", en: "Region & Privacy" },
  "profile.name_label": { zh: "顯示名稱", en: "Display name" },
  "profile.name_ph": { zh: "你的名字", en: "Your name" },
  "profile.country_label": { zh: "預設所在國家（決定神話風格）", en: "Default country (sets myth style)" },
  "profile.country_ph": { zh: "選擇國家", en: "Select country" },
  "profile.show_t": { zh: "公開分享時顯示國家", en: "Show country on public shares" },
  "profile.show_d": { zh: "關閉後光球會落在海洋，不顯示國家", en: "When off, your orb floats on the ocean with no country" },
  "profile.save": { zh: "儲存設定", en: "Save settings" },
  "profile.rem_title": { zh: "每日提醒", en: "Daily Reminder" },
  "profile.rem_enable_t": { zh: "開啟每日記錄提醒", en: "Enable daily reminder" },
  "profile.rem_enable_d": { zh: "提醒你記錄 3 件值得開心的小事", en: "Reminds you to log 3 happy things" },
  "profile.rem_time": { zh: "提醒時間", en: "Reminder time" },
  "profile.save_rem": { zh: "儲存提醒", en: "Save reminder" },
  "profile.enable_push": { zh: "開啟推播通知", en: "Enable push" },
  "profile.saved": { zh: "個人設定已更新", en: "Profile updated" },
  "profile.rem_saved": { zh: "提醒設定已更新", en: "Reminder updated" },
  "profile.push_no": { zh: "此瀏覽器不支援通知", en: "Notifications not supported" },
  "profile.push_ok": { zh: "已開啟推播通知", en: "Push notifications enabled" },
  "profile.push_body": { zh: "太好了！我會提醒你記錄三件開心的小事 ✨", en: "Great! I'll remind you to log three happy things ✨" },
  "profile.push_deny": { zh: "尚未授權通知", en: "Notifications not granted" },

  "welcome.title": { zh: "綁定成功，歡迎回來", en: "Linked! Welcome back" },
  "welcome.desc": { zh: "{name}你的魔法旅程已永久保存，之後在任何裝置都能延續 ✨", en: "{name}your journey is saved forever — continue on any device ✨" },
  "welcome.journals": { zh: "篇魔法日記", en: "magic diaries" },
  "welcome.journeys": { zh: "段魔法旅程", en: "journeys" },
  "welcome.shares": { zh: "則地圖分享", en: "map shares" },
  "welcome.creatures": { zh: "隻專屬生物", en: "creatures" },
  "welcome.continue": { zh: "繼續我的魔法旅程", en: "Continue my journey" },
  "story.myth": { zh: "世界神話", en: "World Myth" },
  "story.lucky_title": { zh: "今日幸運生物", en: "Today's Lucky Companions" },
  "chat.greeting": { zh: "嗨，今天過得如何呢？跟我聊聊今天發生的事吧，聊完之後按下方的「施展魔法轉譯」，我會把今天變成一個魔法故事，還會有幸運生物來找你 ✨", en: "Hi! How was your day? Chat with me about it, then tap 'Cast Magic Translation' below — I'll turn your day into a magical story, and lucky creatures will come find you ✨" },
  "chat.ph": { zh: "跟魔法夥伴聊聊今天...", en: "Tell your companion about today..." },
  "chat.cast": { zh: "施展魔法轉譯 · 把今天變成魔法故事", en: "Cast Magic Translation · Turn today into a story" },
  "chat.casting": { zh: "魔法轉譯中...", en: "Casting magic..." },
  "chat.companion_label": { zh: "今日夥伴", en: "Today's companion" },
  "chat.companion_none": { zh: "點我挑選", en: "tap to pick" },
  "chat.today": { zh: "今天", en: "Today" },
  "chat.streak": { zh: "連續 {n} 天", en: "{n}-day streak" },
  "creatures.gen_art": { zh: "生成插畫", en: "Generate art" },
  "creatures.gen_arting": { zh: "繪製中...", en: "Painting..." },
  "creatures.art_done": { zh: "插畫完成 ✨", en: "Artwork ready ✨" },

  "manifest.title": { zh: "顯化魔法日記", en: "Manifestation Journal" },
  "manifest.sub": { zh: "寫下你想顯化的願望，讓魔法把它化為現在式的肯定與觀想", en: "Write the wish you want to manifest — magic turns it into affirmation and vision" },
  "manifest.input_label": { zh: "我想顯化的願望", en: "The wish I want to manifest" },
  "manifest.input_ph": { zh: "例如：我想找到一份充滿熱情的工作", en: "e.g. I want to find work I'm truly passionate about" },
  "manifest.cast": { zh: "施展顯化魔法", en: "Cast Manifestation" },
  "manifest.casting": { zh: "顯化魔法施展中...", en: "Casting manifestation..." },
  "manifest.my": { zh: "我的顯化願望", en: "My manifestations" },
  "manifest.empty_t": { zh: "還沒有顯化願望", en: "No manifestations yet" },
  "manifest.empty_s": { zh: "寫下第一個願望，開始顯化的魔法吧 ✨", en: "Write your first wish to begin the magic ✨" },
  "manifest.affirmation": { zh: "肯定語句", en: "Affirmation" },
  "manifest.visualization": { zh: "觀想引導", en: "Visualization" },
  "manifest.fulfill": { zh: "標記為已顯化", en: "Mark as manifested" },
  "manifest.fulfilled": { zh: "已顯化 ✨", en: "Manifested ✨" },
  "manifest.need": { zh: "請先寫下你想顯化的願望", en: "Please write your wish first" },
  "manifest.cast_ok": { zh: "顯化魔法已施展 ✨", en: "Manifestation cast ✨" },
  "manifest.fulfilled_ok": { zh: "恭喜！願望已顯化 🌟", en: "Congrats! Your wish is manifested 🌟" },
};

export const MOODS = [
  { key: "joyful", emoji: "😊", zh: "開心", en: "Joyful" },
  { key: "excited", emoji: "🤩", zh: "興奮", en: "Excited" },
  { key: "calm", emoji: "😌", zh: "平靜", en: "Calm" },
  { key: "brave", emoji: "🦁", zh: "勇敢", en: "Brave" },
  { key: "tired", emoji: "😪", zh: "疲憊", en: "Tired" },
  { key: "reflective", emoji: "🌙", zh: "省思", en: "Reflective" },
  { key: "hopeful", emoji: "✨", zh: "充滿希望", en: "Hopeful" },
  { key: "playful", emoji: "🦊", zh: "俏皮", en: "Playful" },
];

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("lang");
    if (saved) return saved;
    const sys = (navigator.language || "en").toLowerCase().startsWith("zh") ? "zh" : "en";
    localStorage.setItem("lang", sys);
    return sys;
  });

  const setLang = useCallback((l) => {
    localStorage.setItem("lang", l);
    setLangState(l);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const entry = DICT[key];
      let str = entry ? entry[lang] ?? entry.zh : key;
      if (vars) {
        Object.keys(vars).forEach((k) => {
          str = str.replace(`{${k}}`, vars[k]);
        });
      }
      return str;
    },
    [lang]
  );

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useT = () => useContext(LangContext);
export const moodLabel = (key, lang) => {
  const m = MOODS.find((x) => x.key === key);
  return m ? m[lang] || m.zh : key;
};
